const messages = {
    en: {
        register: "Sign up",
        clearValues: "Clear Values",
        name: "Name",
        emailAddress: "E-mail address",
        password: "Password",
        confirmPasword: "Confirm password",
        enterTextInBlue: "Enter text in blue below",
        required: "Required",
        fourOrMore: "Must be 4 characters or more",
        emailIssue: "Invalid email address",
        eightOrMore: 'Must be 8 characters or more',
        fifteenOrLess: 'Must be 15 characters or less',
        passworsNotMatching: "Passwords aren't matching",
        login: "Login"

    },
    ru: {
        register: "Отправить",
        clearValues: "Oчистить формy",
        name: "Имя",
        emailAddress: "Адрес электронной почты",
        password: "Пароль",
        confirmPasword: "Подтвердить пароль",
        enterTextInBlue: "Введите текст, выделенный синим цветом",
        required: "Обязательное поле",
        fourOrMore: "Должно быть 4 символа или более",
        emailIssue: "Неверный адрес электронной почты",
        eightOrMore: "Должно быть 8 символов или более",
        fifteenOrLess: 'Должно быть не более 15 символов',
        passworsNotMatching: "Пароли не совпадают",
        login: "Aвторизоваться"
    }
  };

  export default messages;